/*
 * @Author: your name
 * @Date: 2021-11-04 11:12:33
 * @LastEditTime: 2021-12-09 10:08:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \指纹系统\founder_vue\src\store\modules\zwbj.js
 */
import {SET_LOADING} from './mutations-types'

const state = {
  // 是否处于加载中
  loading: false,
}

const mutations = {
  [SET_LOADING](state, content) {
    state.loading = content
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
